import React from 'react';

import { ColourPicker, Divider, Select, Subheading, Switch } from '../../../WidgetConfiguratorComponents/FormGroups';
import { EXTREMES_SCOPE } from '../MinimaAndMaxima';

export const ExtremesConfigurator = ({ onChange, item }) => {
    const {
        displayExtremes,
        scope,
        highlightMinima,
        highlightMaxima,
        minimaReference,
        maximaReference,
        colour,
        minimaColour,
        maximaColour,
        minimaHighlightOnTimeline,
        maximaHighlightOnTimeline,
    } = item;

    return (
        <>
            <Switch label='Display extremes' value={displayExtremes} onChange={(displayExtremes) => onChange({ ...item, displayExtremes })} />
            {displayExtremes && (
                <>
                    <Select label='Scope' value={scope} values={Object.values(EXTREMES_SCOPE)} onChange={(scope) => onChange({ ...item, scope })} />
                    <Divider />
                    <Subheading text='Minima' />
                    <Switch
                        label='Enable'
                        value={highlightMinima}
                        onChange={(highlightMinima) => onChange({ ...item, highlightMinima, minimaColour: highlightMinima ? minimaColour : null })}
                    />
                    {highlightMinima && (
                        <>
                            <ColourPicker label='Colour' value={minimaColour || colour} onChange={(minimaColour) => onChange({ ...item, minimaColour })} />
                            <Select
                                label='Display values'
                                mode='multiple'
                                value={minimaReference || []}
                                onChange={(minimaReference) => onChange({ ...item, minimaReference })}
                                values={['xAxis', 'yAxis']}
                            />
                            <Switch
                                label='Highlight on timeline'
                                value={minimaHighlightOnTimeline}
                                onChange={(minimaHighlightOnTimeline) => onChange({ ...item, minimaHighlightOnTimeline })}
                            />
                        </>
                    )}
                    <Divider />
                    <Subheading text='Maxima' />
                    <Switch
                        label='Enable'
                        value={highlightMaxima}
                        onChange={(highlightMaxima) => onChange({ ...item, highlightMaxima, maximaColour: highlightMaxima ? maximaColour : null })}
                    />
                    {highlightMaxima && (
                        <>
                            <ColourPicker label='Colour' value={maximaColour || colour} onChange={(maximaColour) => onChange({ ...item, maximaColour })} />
                            <Select
                                label='Display values'
                                mode='multiple'
                                value={maximaReference || []}
                                onChange={(maximaReference) => onChange({ ...item, maximaReference })}
                                values={['xAxis', 'yAxis']}
                            />
                            <Switch
                                label='Highlight on timeline'
                                value={maximaHighlightOnTimeline}
                                onChange={(maximaHighlightOnTimeline) => onChange({ ...item, maximaHighlightOnTimeline })}
                            />
                        </>
                    )}
                    <Divider />
                </>
            )}
        </>
    );
};
